import React from "react";
import { DraggableProvided } from "react-beautiful-dnd";

import { StackProps } from "@mui/material";
import { DealStage, DealStageItem, UpdateDealStageData } from "store/types";
import { INotePopup } from "..";
import { OpportunitiesCard } from "../Pipeline-card/OpportunitiesCard";
import { Column } from "./Column";

interface Props extends StackProps {
  stage: DealStage;
  updateColumn: (data: UpdateDealStageData) => void;
}

export const OpportunitiesColumn: React.FC<Props> = ({ stage, updateColumn }) => {
  const renderCard = (
    item: DealStageItem,
    draggableProvided: DraggableProvided,
    isDragging: boolean,
    stageId: number,
    setNotePopup?: (data: INotePopup) => void
  ) => {
    void isDragging;
    void stageId;
    void setNotePopup;
    return (
      <div
        ref={draggableProvided.innerRef}
        {...draggableProvided.draggableProps}
        {...draggableProvided.dragHandleProps}
        style={{
          ...draggableProvided.draggableProps.style,
          userSelect: "none",
          WebkitUserSelect: "none",
          msUserSelect: "none",
          MozUserSelect: "none"
        }}
      >
        <OpportunitiesCard {...item} />
      </div>
    );
  };

  return (
    <Column
      stage={stage}
      headerColor="#0a3142"
      showControls={false}
      showStatusMenu={false}
      updateColumn={updateColumn}
      renderCard={renderCard}
    />
  );
};
